<template lang="html">

    <section class="section-links flex wrap">
  
      <article class="col-50 pad-sec" v-for="(e,key) in data">

        <router-link :to="enlaces[e]"></router-link>
    

        <div class="container-text">
          <h3 class="title title-36" v-html="$t(`otras_secciones['${e}'].titulo`)"></h3>
          <p v-html="$t(`otras_secciones['${e}'].texto`)"></p>
          <p class="go"><span v-html="$t(`otras_secciones['${e}'].boton_texto`)"></span><i class="fa fa-long-arrow-right" aria-hidden="true"></i></p>
        </div>

      </article>

    </section>

</template>

<script lang="js">
  
  import {mapGetters} from 'vuex'

  export default  {
    name: 'acceso-a-secciones',
    props: ['data'],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
      ...mapGetters(['getTexts']),
      enlaces : function (){
        return this.getTexts.enlaces;
      },
      textos : function (){
        return this.getTexts.otras_secciones;
      }
    }
}
</script>

<style scoped>
  .acceso-a-secciones {

  }
</style>



// WEBPACK FOOTER //
// src/components/parts/acceso-a-secciones.vue